const reducer = (previousValue, currentValue) => previousValue + currentValue;

export default function optimizationResults(meters = [], impact = []) {
  function calculateContractsCostNew(meter, consumption, energycost) {
    if (meters.length && impact?.newContract?.length) {
      if (impact?.energy == "electricity") {
        if (!consumption) //other monthly cost and kwh cost
        {
          let cost = 0;
          if (impact?.newContract[0]?.details?.otherunitcost && Object.keys(meter?.details).includes("total")) {
            cost = meter?.details?.total * impact?.newContract[0]?.details?.otherunitcost;
          }
          if (impact?.newContract[0]?.details?.othermonthlycost) {
            cost += 12 * impact?.newContract[0]?.details?.othermonthlycost;
          }
          //console.log(meter?.details?.total, cost);
          return cost;
        }
        else if (Object.keys(meter?.details).includes(consumption)) { //for hpe, hce, base, ...
          return (
            meter?.details?.[consumption] * impact?.newContract[0]?.details?.[energycost]
          );
        } else {
          return 0;
        }
      } else {
        let cost = 0;
        if (impact?.newContract[0]?.details?.energycost && Object.keys(meter?.details).includes("total")) {
          cost = meter?.details?.total * impact?.newContract[0]?.details?.energycost;
        }
        if (impact?.newContract[0]?.details?.othermonthlycost) {
          cost += 12 * impact?.newContract[0]?.details?.othermonthlycost;
        }
        //console.log(meter?.details?.total, cost);
        return cost;
      }
    }
  }

  function calculateContractsCostOld(meter, consumption, energycost) {
    let contract = impact?.associatedContracts?.find(
      (c) => c.uuid == meter?.details?.associatedcontractid
    );
    if (meters.length && contract) {
      if (impact?.energy == "electricity") {
        if (!consumption) //other monthly cost and kwh cost
        {
          let cost = 0;
          if (contract.details?.otherunitcost && Object.keys(meter?.details).includes("total")) {
            cost = meter?.details?.total * contract.details?.otherunitcost;
          }
          if (contract.details?.othermonthlycost) {
            cost += 12 * contract.details?.othermonthlycost;
          }
          //console.log(meter?.details?.total, cost);
          return cost;
        }
        else if (Object.keys(meter?.details).includes(consumption)) {
          return (meter?.details?.[consumption] * contract.details?.[energycost]);
        } else {
          let cost = 0;
          if (contract.details?.energycost && Object.keys(meter?.details).includes("total")) {
            cost = meter?.details?.total * contract.details?.energycost;
          }
          if (contract.details?.othermonthlycost) {
            cost += 12 * contract.details?.othermonthlycost;
          }
          //console.log(meter?.details?.total, cost);
          return cost;
        }
      }
    }
  }

  function calculateContractsCo2NewContract(meter) {
    if (meters.length && impact?.newContract?.length) {
      if (Object.keys(meter?.details).includes("total")) {
        return (
          meter?.details?.total * impact?.newContract[0]?.details?.co2ratio
        );
      } else {
        return 0;
      }
    }
  }
  function calculateContractsCo2OldContract(meter) {
    if (meters.length && impact?.newContract?.length) {
      if (Object.keys(meter?.details).includes("total")) {
        return (
          meter?.details?.total *
          impact?.associatedContracts?.find(
            (c) => c.uuid == meter?.details?.associatedcontractid
          )?.details?.co2ratio
        );
      } else {
        return 0;
      }
    }
  }

  function totalContractsCostNewContract(consumption, energycost) {
    return meters
      .map((meter) => calculateContractsCostNew(meter, consumption, energycost))
      .filter(Boolean)
      .reduce(reducer, 0);
  }

  function totalContractsCostOldContract(consumption, energycost) {
    return meters
      .map((meter) => calculateContractsCostOld(meter, consumption, energycost))
      .filter(Boolean)
      .reduce(reducer, 0);
  }


  function totalContractsCo2NewContract() {
    return meters
      .map((meter) =>
        calculateContractsCo2NewContract(meter)
      )
      .filter(Boolean)
      .reduce(reducer, 0);
  }

  function totalContractsCo2OldContract() {
    return meters
      .map((meter) =>
        calculateContractsCo2OldContract(meter)
      )
      .filter(Boolean)
      .reduce(reducer, 0);
  }

  function totalContractsCo2() {
    return (
      (totalContractsCo2OldContract() -
        totalContractsCo2NewContract()).toFixed(0)
    );
  }

  function evolutionContractsCo2() {
    //console.log(totalContractsCo2NewContract());
   // console.log(totalContractsCo2OldContract());
    let oldcost = totalContractsCo2OldContract();
    let newcost = totalContractsCo2NewContract();
    if (!oldcost || !newcost)
      return 0;
    else
      return (
        (
          (1 - (newcost /
            oldcost)) *
          100
        ).toFixed(2) ?? 0
      );
  }

  let totalEarnings = 0;
  let totalEvolution = 0
  let totalCo2 = 0;
  let totalEvolutionCo2 = 0;

  if (meters.length && impact?.newContract?.length) {
    if (impact?.energy == "electricity") {


      const totalCostNewhce = totalContractsCostNewContract("hce", "energycosthce");
      const totalCostNewhch = totalContractsCostNewContract("hch", "energycosthch");
      const totalCostNewhph = totalContractsCostNewContract("hph", "energycosthph");
      const totalCostNewhpe = totalContractsCostNewContract("hpe", "energycosthpe");
      const totalCostNewpointe = totalContractsCostNewContract("pointe", "energycostpointe");
      const totalCostNewhc = totalContractsCostNewContract("hc", "energycosthc");
      const totalCostNewhp = totalContractsCostNewContract("hp", "energycosthp");
      const totalCostNewbase = totalContractsCostNewContract("base", "energycostbase");
      const totalCostNewother = totalContractsCostNewContract();

      const totalCostNewArr = [
        totalCostNewhce,
        totalCostNewhch,
        totalCostNewhph,
        totalCostNewhpe,
        totalCostNewpointe,
        totalCostNewhc,
        totalCostNewhp,
        totalCostNewbase,
        totalCostNewother,
      ];

      const totalCostOldhce = totalContractsCostOldContract("hce", "energycosthce");
      const totalCostOldhch = totalContractsCostOldContract("hch", "energycosthch");
      const totalCostOldhph = totalContractsCostOldContract("hph", "energycosthph");
      const totalCostOldhpe = totalContractsCostOldContract("hpe", "energycosthpe");
      const totalCostOldpointe = totalContractsCostOldContract("pointe", "energycostpointe");
      const totalCostOldhc = totalContractsCostOldContract("hc", "energycosthc");
      const totalCostOldhp = totalContractsCostOldContract("hp", "energycosthp");
      const totalCostOldbase = totalContractsCostOldContract("base", "energycostbase");
      const totalCostOldother = totalContractsCostOldContract();

      const totalCostOldArr = [
        totalCostOldhce,
        totalCostOldhch,
        totalCostOldhph,
        totalCostOldhpe,
        totalCostOldpointe,
        totalCostOldhc,
        totalCostOldhp,
        totalCostOldbase,
        totalCostOldother,
      ];

      //console.log(totalCostOldArr.filter(Boolean).reduce(reducer, 0));
      //console.log(totalCostNewArr.filter(Boolean).reduce(reducer, 0));
      let oldcost = totalCostOldArr.filter(Boolean).reduce(reducer, 0);
      let newcost = totalCostNewArr.filter(Boolean).reduce(reducer, 0);
      totalEarnings = (oldcost - newcost).toFixed(2);
      //console.log(totalEarnings);
      if (oldcost && newcost)
        totalEvolution =
          (
            (1 - (newcost /
              oldcost)) *
            100
          ).toFixed(2) ?? 0;

     // console.log(totalEvolution);

      totalCo2 = totalContractsCo2() ?? 0;
      //console.log(totalCo2);
      totalEvolutionCo2 = evolutionContractsCo2() ?? 0;
      //console.log(totalEvolutionCo2);

    } else {
      let oldcost = totalContractsCostOldContract();
      let newcost = totalContractsCostNewContract();
      totalEarnings = (oldcost - newcost).toFixed(2)
      if (oldcost && newcost)
        totalEvolution = (
          (oldcost / newcost) * 100).toFixed(2) ?? 0;
      totalCo2 = totalContractsCo2() ?? 0;
      totalEvolutionCo2 = evolutionContractsCo2() ?? 0;
    }
  }

  //console.log(totalEvolution);

  return {
    totalEarnings,
    totalEvolution,
    totalCo2,
    totalEvolutionCo2,
  };
}
